import React from 'react';

function Portfolio() {
  return (
    <div id="portfolio" style={{ marginTop: '20px' }}>
      <h2>My Portfolio</h2>
      <p>这里展示我的作品。</p>
    </div>
  );
}

export default Portfolio;
